import { jsx as _jsx } from "react/jsx-runtime";
import { ModalInputBase } from '../../../../components/modal_input_base/modal_input_base';
export function ModalReprovar(_a) {
    var open = _a.open, onClose = _a.onClose, onConfirm = _a.onConfirm, motivo = _a.motivo, onMotivoChange = _a.onMotivoChange, erroMotivo = _a.erroMotivo, isSubmitting = _a.isSubmitting;
    return (_jsx(ModalInputBase, { open: open, onClose: onClose, onConfirm: onConfirm, isSubmitting: isSubmitting, title: 'Reprovar Registro', titleColor: '#991B1B', message: 'O colaborador poder\u00E1 justificar as horas pendentes.', labelInput: 'Motivo da Reprova\u00E7\u00E3o (Obrigat\u00F3rio)*', placeholderInput: 'Ex: Foto n\u00E3o confere, localiza\u00E7\u00E3o indevida...', valueInput: motivo, onChangeInput: function (val) {
            if (val.length <= 200) {
                onMotivoChange(val);
            }
        }, errorInput: erroMotivo, helperText: erroMotivo ? 'O motivo é obrigatório para registrar a recusa.' : "".concat(motivo.length, "/200"), onHelperTextProps: {
            sx: {
                ml: 0,
                mt: 0.5,
                display: 'flex',
                justifyContent: erroMotivo ? 'flex-start' : 'flex-end',
                fontWeight: 500,
            },
        }, confirmText: 'CONFIRMAR RECUSA', confirmColor: '#DC2626', confirmHoverColor: '#B91C1C' }));
}
